<style>
  .DeadLine {
    background-color: #ff0000 !important;
  }

  .OneMonth {
    background-color: #eeb20e !important;
  }

  .TwoMonth {
    background-color: #a595ff !important;
  }

  .Selected {
    background-color: #86e7d1 !important;
  }
</style>

<div class="col-md-12 mb-30" [hidden]="Data_Change_Operaion_Id!=-1 || Data_Change_Service.id>0  || Data_Change_Operation.id>0">
  <div class="card card-statistics h-100">
    <div class="card-body" >
      <h5 class="card-title border-0 pb-0">Details</h5>

      <div class="row">

        <div class="col-md-4" (click)="Set__filter_DeviceBehfa_DataList(DataList_DeviceBehfa,00)" >
          <div class="card card-statistics h-100">
            <div class="card-body" [ngClass]="{'Selected': DataList_DeviceBehfa_Type==00}">
              <div class="clearfix">
                <div class="float-left icon-box bg-info rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-building highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark">Behfa Equipment Count </p>
                  <h4>{{DataList_DeviceBehfa_Total.length}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4" (click)="Set__filter_DeviceBehfa_DataList(activeStatus_DeviceBehfa,11)" >
          <div class="card card-statistics h-100">
            <div class="card-body" [ngClass]="{'Selected': DataList_DeviceBehfa_Type==11}">
              <div class="clearfix">
                <div class="float-left icon-box bg-success rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-unlock highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark">Behfa Equipment Count <b>Active</b></p>
                  <h4>{{activeStatus_DeviceBehfa.length}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4" (click)="Set__filter_DeviceBehfa_DataList(disactiveStatus_DeviceBehfa,22)" >
          <div class="card card-statistics h-100">
            <div class="card-body" [ngClass]="{'Selected': DataList_DeviceBehfa_Type==22}">
              <div class="clearfix">
                <div class="float-left icon-box bg-warning rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-lock highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark">Behfa Equipment Count <b>Inactive</b></p>
                  <h4>{{disactiveStatus_DeviceBehfa.length}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>

      <br />
      <br />

      <div class="row">

        <div class="col-md-4"(click)="Set__filter_DeviceBehfa_DataList(repairStatus_DeviceBehfa,33)">
          <div class="card card-statistics h-100">
            <div class="card-body" [ngClass]="{'Selected': DataList_DeviceBehfa_Type==33}">
              <div class="clearfix">
                <div class="float-left icon-box bg-info rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-wrench highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark">Behfa Equipment Count <b>Under Repair</b></p>
                  <h4>{{repairStatus_DeviceBehfa.length}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4" (click)="Set__filter_DeviceBehfa_DataList(calibrationStatus_DeviceBehfa,44)">
          <div class="card card-statistics h-100">
            <div class="card-body" [ngClass]="{'Selected': DataList_DeviceBehfa_Type==44}">
              <div class="clearfix">
                <div class="float-left icon-box bg-warning rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-flask highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark">Behfa Equipment Count <b>Under Calibration</b></p>
                  <h4>{{calibrationStatus_DeviceBehfa.length}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4" (click)="Set__filter_DeviceBehfa_DataList(outorderStatus_DeviceBehfa,55)">
          <div class="card card-statistics h-100">
            <div class="card-body" [ngClass]="{'Selected': DataList_DeviceBehfa_Type==55}">
              <div class="clearfix">
                <div class="float-left icon-box bg-danger rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-warning highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark">Behfa Equipment Count <b>Permanently Inactive</b></p>
                  <h4>{{outorderStatus_DeviceBehfa.length}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <br />
      <br />

      <div class="row">
        <div class="col-md-4" (click)="Set__filter_DeviceBehfa_DataList(two_Month_DeviceBehfa,2)">
          <div class="card card-statistics h-100">
            <div class="card-body" [ngClass]="{'Selected': DataList_DeviceBehfa_Type==2}">
              <div class="clearfix">
                <div class="float-left icon-box bg-info rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-building highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark"> Equipment Behfa <b>Expires in Two Months</b> </p>
                  <h4>{{two_Month_DeviceBehfa.length}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4" (click)="Set__filter_DeviceBehfa_DataList(one_Month_DeviceBehfa,1)">
          <div class="card card-statistics h-100">
            <div class="card-body" [ngClass]="{'Selected': DataList_DeviceBehfa_Type==1}">
              <div class="clearfix">
                <div class="float-left icon-box bg-warning rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-building highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark"> Equipment Behfa <b>Expires in One Month</b> </p>
                  <h4>{{one_Month_DeviceBehfa.length}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4" (click)="Set__filter_DeviceBehfa_DataList(zero_Month_DeviceBehfa,77)">
          <div class="card card-statistics h-100">
            <div class="card-body" [ngClass]="{'Selected': DataList_DeviceBehfa_Type==77}">
              <div class="clearfix">
                <div class="float-left icon-box bg-danger rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-building highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark"> Behfa Equipment Count <b>Expired</b> </p>
                  <h4>{{zero_Month_DeviceBehfa.length}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Code BEHFA</label>
          <input [(ngModel)]="Filter_Code" (keyup.enter)="ReadData_DeviceBehfa(1)" (keyup)="Change_Filter_title()" name="Filter_Code" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Description</label>
          <input [(ngModel)]="Filter_Description" (keyup.enter)="ReadData_DeviceBehfa(1)" (keyup)="Change_Filter_title()" name="Filter_Description" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Model</label>
          <input [(ngModel)]="Filter_Model" (keyup.enter)="ReadData_DeviceBehfa(1)" (keyup)="Change_Filter_title()" name="Filter_Model" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
      </div>


      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Manufacturer</label>
          <input [(ngModel)]="Filter_Manufacturer" (keyup.enter)="ReadData_DeviceBehfa(1)" (keyup)="Change_Filter_title()" name="Filter_Manufacturer" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Group</label>
          <select  (change)="Read_Second_Device_Group()" (keyup.enter)="ReadData_DeviceBehfa(1)" name="First_Device_Group_Selected" [(ngModel)]="First_Device_Group_Selected" class="custom-select">
            <option value="0">All</option>
            <option  *ngFor="let item of DataList_First_Device_Group" [value]="item.id" >{{item.title}}</option>
          </select>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Subgroup</label>
          <select  [(ngModel)]="Second_Device_Group_Selected" (keyup.enter)="ReadData_DeviceBehfa(1)" name="Second_Device_Group_Selected" class="custom-select">
            <option value="0">All</option>
            <option  *ngFor="let item of DataList_Second_Device_Group" [value]="item.id" >{{item.title}}</option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_DeviceBehfa(1)" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>

          <button *ngIf="!Procssing" (click)="Set_Change_Operaion(0)" type="button" class="btn btn-success"
            style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add New Record </button>

          <button *ngIf="!Procssing" (click)="exportexcel()" type="button" class="btn btn-warning"
            style="margin-right: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>

          <a *ngIf="!Procssing" href="{{BaseUrlFilter}}" target="_blank" style="margin-right: 5px;"> <button
              type="button" class="btn btn-info"><i class="fa fa-qrcode"></i> QR Code </button> </a>

          <a *ngIf="!Procssing" href="{{BaseUrlFilter2}}" target="_blank" style="margin-right: 5px;"> <button
              type="button" class="btn btn-danger"><i class="fa fa-qrcode"></i> QR Code 2 </button> </a>

          <button *ngIf="Procssing" type="button" class="btn btn-info" style="margin-right: 5px;"> Please wait... <i
                class="fa fa-spin fa-spinner"></i> </button>

        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>
                <input type="checkbox" [checked]="Check_All" (click)="onChange_CheckAll()" />
              </th>
              <th>#</th>
              <th style="cursor: pointer;" (click)="ChangeOrder('code')">
                <i *ngIf="order=='code' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='code' && orderreverse" class="fa fa-sort-up"></i>
                System ID
              </th>
              <th style="cursor: pointer;" (click)="ChangeOrder('groupTitle')">
                <i *ngIf="order=='groupTitle' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='groupTitle' && orderreverse" class="fa fa-sort-up"></i>
                Group
              </th>
              <th style="cursor: pointer;" (click)="ChangeOrder('description')">
                <i *ngIf="order=='description' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='description' && orderreverse" class="fa fa-sort-up"></i>
                Description
              </th>
              <th style="cursor: pointer;" (click)="ChangeOrder('manufacturer')">
                <i *ngIf="order=='manufacturer' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='manufacturer' && orderreverse" class="fa fa-sort-up"></i>
                Manufacturer
              </th>
              <th style="cursor: pointer;" (click)="ChangeOrder('model')">
                <i *ngIf="order=='model' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='model' && orderreverse" class="fa fa-sort-up"></i>
                Model
              </th>
              <th style="cursor: pointer;" (click)="ChangeOrder('codeBEHFA')">
                <i *ngIf="order=='codeBEHFA' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='codeBEHFA' && orderreverse" class="fa fa-sort-up"></i>
                Code BEHFA
              </th>
              <th style="cursor: pointer;" (click)="ChangeOrder('certificateNo')">
                <i *ngIf="order=='certificateNo' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='certificateNo' && orderreverse" class="fa fa-sort-up"></i>
                Certificate No.
              </th>
              <th style="cursor: pointer;" (click)="ChangeOrder('calDue')">
                <i *ngIf="order=='calDue' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='calDue' && orderreverse" class="fa fa-sort-up"></i>
                Cal. Due
              </th>

              <th>Status</th>
              <th>Date</th>
              <th>User</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>

            <tr *ngFor="let item of DataList_DeviceBehfa| orderBy: order : orderreverse| paginate
            : {
                id: 'DataList_DeviceBehfaTable',
                itemsPerPage: 50,
                currentPage: page,
                totalItems: DataList_DeviceBehfa.length
              }"
              [ngClass]="{'DeadLine': item.alarm===3 ,'OneMonth': item.alarm===2,'TwoMonth': item.alarm===1}">
              <td>
                <input type="checkbox" *ngIf="item.status==1 || item.status==2" [checked]="item.selected"
                  (click)="onChange_CheckItem(item)" />
              </td>
              <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.groupTitle}}</td>
              <td class="EnglishClm">{{item.description}}</td>
              <td class="EnglishClm">{{item.manufacturer}}</td>
              <td class="EnglishClm">{{item.model}}</td>
              <td class="EnglishClm">{{item.codeBEHFA}}</td>
              <td class="EnglishClm">{{item.certificateNo}}</td>
              <td class="EnglishClm">
                <p *ngIf="item.calDueType==1">{{item.calDueMiladi}}</p>
                <p *ngIf="item.calDueType==0">{{item.calDueShamsi}}</p>
              </td>
              <td>
                <p *ngIf="item.status==1" style="color: #489b39;">Active</p>
                <p *ngIf="item.status==2" style="color: crimson;">Inactive</p>
                <p *ngIf="item.status==3" style="color: mediumblue;">Under Repair</p>
                <p *ngIf="item.status==4" style="color: gold;">Under Calibration</p>
                <p *ngIf="item.status==5" style="color: rgb(255, 5, 5);">Permanently Inactive</p>

              </td>

              <td>{{item.persianDate}}</td>
              <td>{{item.username}} </td>
              <td>
                <div class="btn-group"  role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a class="dropdown-item" style="cursor: pointer;" (click)="Set_Change_Operaion(item.id)"><i
                          class="fa fa-edit"></i> Edit </a>
                      <a target="_blank" *ngIf="item.status==1 || item.status==2" href="{{BaseUrl}}{{item.id}}"
                        class="dropdown-item"><i class="fa fa-qrcode"></i> QR Code </a>
                      <a target="_blank" *ngIf="item.status==1 || item.status==2" href="{{BaseUrl2}}{{item.id}}"
                        class="dropdown-item"><i class="fa fa-qrcode"></i> QR Code 2 </a>

                      <a  style="cursor: pointer;" class="dropdown-item"
                        (click)="Set_Data_Change_Operation(item)"><i class="fa  fa-history"></i> Status Change History </a>

                      <a  style="cursor: pointer;" class="dropdown-item"
                        (click)="Set_Change_Service(item)"><i class="fa fa-wrench"></i> Service History </a>

                      <a *ngIf="item.status!=1 && item.status!=3" style="cursor: pointer;" class="dropdown-item"
                        (click)="openModal(template,item,1)"><i class="fa fa-unlock"></i> Activate </a>
                      <a *ngIf="item.status!=2 && item.status!=3" style="cursor: pointer;" class="dropdown-item"
                        (click)="openModal(template,item,2)"><i class="fa fa-lock"></i> Deactivate </a>

                      <a *ngIf="item.status!=4 && item.status!=3" style="cursor: pointer;" class="dropdown-item"
                        (click)="openModal(template,item,4)"><i class="fa fa-flask"></i> Under Calibration </a>
                        <!--
                      <a style="cursor: pointer;" *ngIf="item.status!=3" class="dropdown-item" (click)="openModal(template,item,5)"><i
                          class="fa fa-warning"></i> Permanently Deactivate </a>-->
                    </div>
                  </div>

                  <div *ngIf="item.DeletingProccess">
                    <img src="assets/Loading.gif" style="width: 25px;" />
                  </div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
        <br/>
        <br/>
        <br/>
        <br/>
      </div>

      <pagination-controls
      id="DataList_DeviceBehfaTable"
      nextLabel="Next"
      previousLabel="Previous"
      (pageChange)="page = $event"
    ></pagination-controls>

      <!--
      <div class="row">
        <div class="btn-group mr-2" role="group" aria-label="First group">
          <button *ngFor="let item of Paging_Button" (click)="ReadData_DeviceBehfa(item)" type="button" class="btn btn-secondary">{{item}}</button>
      </div>
    </div>
      -->

    </div>
  </div>
</div>

<app-DeviceBehfaAdd
  (OnBack_DeviceBehfa_Action)="OnBack_Change_Operaion()"
  *ngIf="Data_Change_Operaion_Id==0">

</app-DeviceBehfaAdd>

<app-DeviceBehfaEdit
  [deviceBehfa_id_Innner]="Data_Change_Operaion_Id"
  [can_Submit_Innner]="Data_Change_Operaion_Submit"
  (OnBack_DeviceBehfa_Edit_Action)="OnBack_Change_Operaion()"
  *ngIf="Data_Change_Operaion_Id>0">

</app-DeviceBehfaEdit>


<app-PMServiceHistory
  *ngIf="Data_Change_Service.id>0"
  [inner_DeviceBehfa]="Data_Change_Service"
  (OnBack_DeviceBehfa_Action)="OnBack_Change_Service($event)">

</app-PMServiceHistory>

<app-DeviceBehfaChangeOperation
  *ngIf="Data_Change_Operation.id>0"
  [deviceBehfa_Innner]="Data_Change_Operation"
  (OnBack_DeviceBehfa_Action)="OnBack_Change_Operation($event)">

</app-DeviceBehfaChangeOperation>

<ng-template #template>
  <div class="modal-header">
    <h4 *ngIf="openModal_Status==1" class="modal-title pull-left">Approve Active Behfa Equipment
      '{{Data_Seleted_Delete.codeBEHFA}}' </h4>
    <h4 *ngIf="openModal_Status==2" class="modal-title pull-left">Approve Inactive Behfa Equipment
      '{{Data_Seleted_Delete.codeBEHFA}}' </h4>
    <h4 *ngIf="openModal_Status==3" class="modal-title pull-left">Approve Under Repair Behfa Equipment
      '{{Data_Seleted_Delete.codeBEHFA}}' </h4>
    <h4 *ngIf="openModal_Status==4" class="modal-title pull-left">Approve Under Calibration Behfa Equipment
      '{{Data_Seleted_Delete.codeBEHFA}}' </h4>
    <h4 *ngIf="openModal_Status==5" class="modal-title pull-left">Confirm Permanent Deactivation of Behfa Equipment
      '{{Data_Seleted_Delete.codeBEHFA}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <textarea type="text" class="form-control" [(ngModel)]="Operation_Dsc" placeholder="Type here...">
        </textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button *ngIf="openModal_Status==1" type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete,1)">
      Activate <i class="fa fa-unlock"></i></button>
    <button *ngIf="openModal_Status==2" type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete,2)">
      Deactivate <i class="fa fa-lock"></i></button>
    <button *ngIf="openModal_Status==3" type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete,3)">
      Under Repair <i class="fa fa-legal"></i></button>
    <button *ngIf="openModal_Status==4" type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete,4)">
      Under Calibration <i class="fa fa-flask"></i></button>
    <button *ngIf="openModal_Status==5" type="button" class="btn btn-warning " (click)="Delete(Data_Seleted_Delete,5)">
      Permanently Deactivate <i class="fa fa-warning"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>

<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>Group</th>
      <th>Description</th>
      <th>Manufacturer</th>
      <th>Model</th>
      <th>Code BEHFA</th>
      <th>Certificate No.</th>
      <th>Cal. Due</th>
      <th>Status</th>
      <th>Date</th>
      <th>User</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_DeviceBehfa">
      <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
      <td>{{item.groupTitle}}</td>
      <td class="EnglishClm">{{item.description}}</td>
      <td class="EnglishClm">{{item.manufacturer}}</td>
      <td class="EnglishClm">{{item.model}}</td>
      <td class="EnglishClm">{{item.codeBEHFA}}</td>
      <td class="EnglishClm">{{item.certificateNo}}</td>
      <td class="EnglishClm">
        <p *ngIf="item.calDueType==1">{{item.calDueMiladi}}</p>
        <p *ngIf="item.calDueType==0">{{item.calDueShamsi}}</p>
      </td>
      <td>
        <p *ngIf="item.status==1" style="color: #489b39;">Active</p>
        <p *ngIf="item.status==2" style="color: crimson;">Inactive</p>
        <p *ngIf="item.status==3" style="color: mediumblue;">Under Repair</p>
        <p *ngIf="item.status==4" style="color: gold;">Under Calibration</p>
        <p *ngIf="item.status==5" style="color:rgb(255, 5, 5);">Permanently Inactive</p>

      </td>
      <td>{{item.persianDate}}</td>
      <td>{{item.username}} </td>
    </tr>
  </tbody>
</table>

